// removed by extract-text-webpack-plugin
module.exports = {"button":"style__button___3Dn9C","button--secondary":"style__button--secondary___37Svv","button--success":"style__button--success___2_i7c","button--danger":"style__button--danger___13RcW","button--auto-width":"style__button--auto-width___1900r"};


//////////////////
// WEBPACK FOOTER
// ./components/Button/style.scss
// module id = 1191
// module chunks = 0